module.exports = __webpack_public_path__ + "img/bg2.422fd332.jpg";